<template>
  <div class='position-relative wrap full-wh'>
    <!-- header -->
    <header class="navbar navbar-expand fixed-top header flex-rsbc">
      <div class='header-title'>Share Drive</div>

      <!-- toggle button at the small-device  -->
      <button class="btn btn-link d-md-none collapsed" type="button" data-toggle="collapse" data-target="#bd-docs-nav"
              aria-controls="bd-docs-nav" aria-expanded="false" aria-label="Toggle docs navigation">
        <img src="../assets/btn_menu.svg">
      </button>
    </header>

    <!-- sidebar + content -->
    <div class="container-fluid a1-content">
      <div class="row flex-rct">
        <!-- sidebar -->
        <div class="col-12 col-md-3 a2-sidebar">
          <nav class="collapse bd-links" id="bd-docs-nav">
            <ul class="nav flex-ccl">
              <label class='btn btn-add flex-rlc'>
                <input type="file" id="file" ref="file" style="display:none;" v-on:change="handleFileUpload()"/>
                <img src="../assets/icon_add.svg">
                <div class='btn-label'>新增</div>
              </label>
              <li><div class='item flex-rlc' @click='selectDriveType(0)'>
                    <img src="../assets/icon_shared.svg">
                    <div class='item-label'>{{driveTypes[0]}}</div>
              </div></li>
              <li><div class='item flex-rlc' @click='selectDriveType(1)' disabled>
                    <img src="../assets/icon_recently.svg">
                    <div class='item-label'>{{driveTypes[1]}}</div>
              </div></li>
              <li><div class='item full-w flex-rlc' @click='selectDriveType(2)' disabled>
                    <img src="../assets/icon_stars.svg">
                    <div class='item-label'>{{driveTypes[2]}}</div>
              </div></li>
              <li><div class='item full-w flex-rlc' @click='selectDriveType(3)'>
                    <img src="../assets/icon_trash.svg">
                    <div class='item-label'>{{driveTypes[3]}}</div>
              </div></li>
            </ul>
            <hr>
            <ul class="nav flex-ccl">
              <li><div class='item flex-rlc no-select'>
                    <img src="../assets/icon_storage_space.svg">
                    <div class='item-label'>儲存空間</div>
              </div></li>
              <li><div class='item flex-rlc no-select'>
                    <div class='item-label no-icon item-desc'>目前使用量：{{usedGB}}</div>
              </div></li>
            </ul>
          </nav>
        </div>
        <!-- list -->
        <div class="col-12 col-md-9 a2-list flex-ccc">
          <div class="align-self-start list-title">{{driveTitle}}</div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">名稱</th>
                <th scope="col">最後修改時間</th>
                <th scope="col">檔案大小</th>
                <th scope="col">功能</th>
              </tr>
            </thead>
            <tbody>
              <tr
                  v-for='(item, key) in items'
                  :key=key>
                <th scope="row" class='flex-rlc'>
                  <img src="../assets/icon_folder.svg" v-show='item.type === 0'>
                  <img src="../assets/file/jpg.svg" v-show='item.type === 1'>
                  <div class="ml-3">{{item.path}}</div>
                </th>
                <td class="txt-c">{{item.updated}}</td>
                <td class="txt-c">{{item.size / 1000}}KB</td>
                <td class="txt-c">
                  <button class="btn flex-ccc">...</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import * as firebase from '../connections/firebase';

export default {
  name: 'ShareDriveMain',
  data() {
    return {
      storageUsed: 19.4,
      file: null,
      driveTypeIdx: 0,
      driveTypes: ['分享雲端空間', '近期存取', '已加星號', '垃圾桶'],
    };
  },
  mounted() {
    firebase.init(this);
  },
  methods: {
    handleFileUpload() {
      if (this.$refs.file.files.length) {
        this.file = this.$refs.file.files[0];

        // check file size
        if (this.file.size <= 1024 * 1024) {
          firebase.uploadFile(this.file);
        }
        else {
          alert('The file size must be less than 1MB.');
        }
      }
    },
    selectDriveType(type) {
      this.driveTypeIdx = type;
    },
  },
  computed: {
    usedGB() {
      return `${this.storageUsed} GB`;
    },
    driveTitle() {
      return this.driveTypes[this.driveTypeIdx];
    },
    items() {
      const items = [];
      if (this.folders) {
        this.folders.forEach((folder) => {
          const item = {};
          item.type = 0;                                  // 0 means folder
          item.path = folder.location.path;
          item.updated = '-';
          item.size = '-';
          items.push(item);
        });
      }
      if (this.files) {
        this.files.forEach((file) => {
          const item = {};
          item.type = 1;                                  // 1 means file
          item.path = file.location.path;
          item.updated = (this.infos[item.path]) ? new Date(this.infos[item.path].updated).toDateString() : '-';
          item.size = (this.infos[item.path]) ? this.infos[item.path].size : '-';
          items.push(item);
        });
      }
      return items;
    },
    ...mapGetters(['folders', 'files', 'infos']),
  },
};
</script>


<style scoped lang='scss'>
@import '../styles/mixins';
@import '../styles/variables';

$header-font-s: $f-size-5;
$header-h: $f-size-5 * 2.5;   // 5rem

.wrap {
  overflow-y: hidden;
}

// header
.header {
  height: $header-h;
  border-bottom: 1px solid $clr-gray-d8;
  background: $clr-white;
}
.header-title {
  color: $clr-main-lv2;
  line-height: $header-h;
  font-size: $header-font-s;
  font-style: italic;
  font-weight: bold;
}

// body
.a1-content {
  position: absolute;
  top: $header-h;
}

// sidebar
.a2-sidebar {
  background-color: $clr-white;
  box-shadow: 3px 0px 6px #98989829;
  border-bottom: 1px solid rgba(0, 0, 0, .1);

  @media(min-width: $limit-w-pc) {
    height: calc(100vh - 5rem);         // $header-h is 5rem
  }
}
.bd-links {
  padding-top: 1rem;
  padding-bottom: 1rem;
  @media(min-width: $limit-w-pc) {
    max-height: calc(100vh - 5rem);     // $header-h is 5rem
    display: block !important;          // Override collapse behaviors
  }
  .btn-add {
    background: $clr-main-lv1;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    color: $clr-white;
    &:hover {
      background: $clr-main-lv2;
    }
    &:focus {
      box-shadow: none;
    }
    img {
      filter: grayscale(100%);
    }
    .btn-label {
      font-size: $f-size-3;
      font-weight: bold;
      line-height: 2;
      @include px(1rem);
    }
  }
  li {
    width: 100%;
  }
  .item {
    padding: 0.75rem;
    color: $clr-gray-7a;
    &:hover, &:active {
      background: $clr-selected;
      img {
        filter: grayscale(0%);
      }
    }
    &[disabled]:hover {
      background: transparent;
    }
    &[disabled] {
      color: $clr-gray-d8;
      img {
        opacity: 0.3;
      }
    }
    &.no-select {
      &:hover {
        background: transparent;
      }
    }
    img {
      filter: grayscale(100%);
    }
    .item-label {
      font-size: $f-size-2;
      font-weight: bold;
      padding-left: 1rem;
    }
    .item-desc {
      color: $clr-gray-9d;
      font-size: $f-size-1;
    }
    .no-icon {
      margin-left: 36px;
    }
  }
}
.a2-list {
  @include px(2rem);
  @include py(1.5rem);
  font-size: $f-size-4;
  .table {
    color: $clr-gray-7b;
    font-size: $f-size-2;
    th, td {
      text-align: left;
    }
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
    .btn {
      width: 1.5rem;
      height: 1.5rem;
      background: $clr-gray-f2;
    }
  }
}
.list-title {
  margin-bottom: 2rem;
}
</style>
